
// import { wechatPay } from './old_index'
import weixinJssdk from './weixinJssdk'
import { judgeUserAgent } from '@/utils/judgeUserAgent'

// 统一性返回格式
const unifiedReturn = (result) => {
  return {
    status: result.status,
    msg: result.msg
  }
}

/**
 * 发起微信 H5 支付请求
 * @param {Object} payload - 支付所需的参数
 * @returns {Promise} - 一个 Promise 对象，成功时返回支付结果，失败时返回错误信息
 */

function wxH5Pay (payload) {
  if (!payload) {
    return Promise.reject('参数错误') 
  }

  // 重定向到微信 H5 支付页面
  document.location.href = payload.payData.mweb_url

  return unifiedReturn({
    status: true,
    msg: '支付中'
  })
}

/**
 * 发起微信公众号支付请求
 * @param {Object} payload - 支付所需的参数
 * @returns {Promise} - 一个 Promise 对象，成功时返回支付结果，失败时返回错误信息
*/

async function wxWebPay (payload) {
  
  if (!payload) {
    return Promise.reject('参数错误')
  }
  try {
     const result = await weixinJssdk({
       ...payload.payData
       // order_sn: payload.order_sn
     })
     
     return unifiedReturn({
       status: false,
       msg: result.message
     })
  }catch (error) {
    return unifiedReturn({
      status: false,
      msg: error
    })
  }
}

/**
 * 发起微信小程序支付请求
 * @param {Object} payload - 支付所需的参数
 * @returns {Promise} - 一个 Promise 对象，成功时返回支付结果，失败时返回错误信息
 * @param {string} payload.order_sn - 订单编号
 * @param {string} payload.pay_id - 支付编号
*/

async function wxMpPay (payload) {
  
  if (!payload) {
    return Promise.reject('参数错误')
  }
  const datas = {
    pay_id: payload.pay_id,
    redirectPath: `/paymentCashier?order_id=${payload.order_sn}`,
    order_sn: payload.order_sn,
    order_type: payload?.order_type
  }

  const paymentInfo = encodeURIComponent(
    JSON.stringify(datas)
  )
  uni.webView.navigateTo({
    url: `/pages/payment/index?requestPayment=${paymentInfo}`
  })

  return unifiedReturn({
    status: false,
    msg: error
  })
}


// 微信支付统一入口

const wechatPay = async (payload) => {
    console.log(judgeUserAgent('WXMP'), 'wxmp')

   // 微信小程序支付
   if (judgeUserAgent('WXMP')) {
     return wxMpPay(payload)
   }

   // 微信公众号支付
   if (judgeUserAgent('WXWEB')) {
     return wxWebPay(payload)
   }

   // 非微信浏览器支付
   if (judgeUserAgent('WXH5')) {
     return wxH5Pay(payload)
   }
}


export {
  wechatPay,
  wxWebPay,
  wxMpPay,
  wxH5Pay
}